<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right">
        <el-button type="primary" @click="create" icon="el-icon-plus"
          >添加</el-button
        >
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="120">
          <template slot-scope="{ row }">
            <el-button type="text" @click="editById(row.DataId)">编辑</el-button>
            <el-button type="text" @click="delRow(row)">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/basedata/basedoc/labelmagent/list";
import editDialog from "@/components/basedata/basedoc/labelmagent/editDialog";

export default {
  name: "tags",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
  },
  methods: {
    create() {
      this.$refs.editDialog.open();
    },
    delRow(row) {
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$refs.list.delRange(row);
      });
    },
  },
};
</script>